import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const STORAGE_KEY = 'antares_cookie_consent';

export default function CookieConsent() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const saved = localStorage.getItem(STORAGE_KEY);
        if (!saved) setVisible(true);
    }, []);

    const accept = () => {
        localStorage.setItem(STORAGE_KEY, 'accepted');
        setVisible(false);
    };

    const decline = () => {
        localStorage.setItem(STORAGE_KEY, 'declined');
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div className="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6">
            <div className="mx-auto max-w-3xl rounded-2xl border border-white/10 bg-[#0F1117] shadow-2xl px-6 py-5 flex flex-col md:flex-row items-start md:items-center gap-4">
                <div className="flex-1 text-sm text-brand-muted leading-relaxed">
                    <span className="text-white font-semibold">🍪 Cookies e Privacidade</span>
                    <span className="ml-2">
                        Utilizamos cookies para melhorar sua experiência. Ao continuar, você concorda com nossa{' '}
                        <Link to="/privacidade" className="text-brand-secondary underline hover:text-white transition">
                            Política de Privacidade
                        </Link>
                        {' '}(LGPD).
                    </span>
                </div>
                <div className="flex gap-3 shrink-0">
                    <button
                        onClick={decline}
                        className="rounded-lg border border-white/20 px-4 py-2 text-sm text-brand-muted hover:text-white hover:border-white/40 transition"
                    >
                        Recusar
                    </button>
                    <button
                        onClick={accept}
                        className="rounded-lg bg-brand-primary px-4 py-2 text-sm font-semibold text-white hover:opacity-90 transition"
                    >
                        Aceitar
                    </button>
                </div>
            </div>
        </div>
    );
}
